module.exports = __webpack_public_path__ + "static/media/mongo.e5eee315.png";